import {api} from '../../helpers/Api'
import {Marketing} from '../../models/AllData'

export const readMarketingMain = (publicToken: string) => {
  return api(publicToken, false).get<void, Marketing>('marketings?main=true&eager=[googleSiteVerifications]')
}